// extracted by mini-css-extract-plugin
module.exports = {"backgroundColor":"disclaimer_backgroundColor__YAEAQ","textClassName":"disclaimer_textClassName__OOfQz","iconClassName":"disclaimer_iconClassName__W9KYR"};